// Catalogue des "Questions à deux" — jumeau exact des clés validées côté serveur
// (OLTODO-backend/src/utils/gardenQuestions.ts). Libellés en FR/EN seulement, comme les tags de
// Mes Désirs (voir gardenDesireTags.ts).
export interface GardenQuestion { key: string; labelFr: string; labelEn: string }

export const GARDEN_QUESTIONS: GardenQuestion[] = [
  { key: "experience_this_year", labelFr: "Quelle expérience aimerais-tu absolument vivre avec moi cette année ?", labelEn: "What experience would you absolutely love to live with me this year?" },
  { key: "place_to_discover", labelFr: "Quel endroit aimerais-tu découvrir avec moi ?", labelEn: "What place would you like to discover with me?" },
  { key: "memory_to_create", labelFr: "Quel souvenir aimerais-tu créer avec moi ?", labelEn: "What memory would you like to create with me?" },
  { key: "do_more_often", labelFr: "Quelle chose aimerais-tu que nous fassions plus souvent ?", labelEn: "What would you like us to do more often?" },
  { key: "dream_together", labelFr: "Quel rêve aimerais-tu réaliser ensemble ?", labelEn: "What dream would you like us to achieve together?" },
  { key: "never_lived_experience", labelFr: "Quelle expérience n'avons-nous encore jamais vécue ?", labelEn: "What experience have we never had together yet?" },
];

export const gardenQuestionByKey = (key: string): GardenQuestion | undefined =>
  GARDEN_QUESTIONS.find(q => q.key === key);
